// Athena showtime queries need a from/to window in "YYYY-MM-DD HH:MM:SS"
// (DateTimeWithoutTimeZone), unlike the old bare "YYYY-MM-DD". Build the bounds in
// local time so the GB day isn't shifted by a UTC conversion.

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

const formatDateTime = (date: Date, time: string) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${time}`;

// Start of today.
export const getFromDate = () => formatDateTime(new Date(), '00:00:00');

// End of the day 21 days out (the showtimes window the site queries).
export const getNextWeekDate = () => {
  const days = 21;
  const date = new Date();
  date.setDate(date.getDate() + days);
  return formatDateTime(date, '23:59:59');
};
